module.exports = __webpack_public_path__ + "static/media/IEEE.fb4e6657.mp4";